import React, { useState } from 'react'
import * as Yup from 'yup'
import { useAuth } from '../core/Auth'
import apiService from "../../../../services/api.service";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import clsx from "clsx";
import ForgotPassword from './ForgotPassword';
import LoginFailedPopup from './LoginFailedPopup';
import { useNavigate } from 'react-router-dom';

const loginSchema = Yup.object().shape({
    email: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Email is required'),
    password: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Password is required'),
})

const initialValues = {
    email: '',
    password: '',
}

export function Login() {
    const [loading, setLoading] = useState(false)
    const {saveAuth, setCurrentUser} = useAuth()
    const [showLoginFailed, setShowLoginFailed] = useState(false)
    const [showForgotPassword, setShowForgotPassword] = useState(false)
    const navigate = useNavigate()

    const {register, handleSubmit, formState: {isValid}}
        = useForm({
        initialValues,
        validationSchema: loginSchema,
        resolver: yupResolver(loginSchema),
    })

    async function onSubmit(data) {
        setLoading(true)
        try {
            const response = await apiService.login(data.email, data.password)
            if (response) {
                saveAuth(response)
                setCurrentUser(response)
                setLoading(false)
                // Login başarılı olduktan sonra dashboard'a yönlendir
                navigate('/dashboard')
            } else {
                setLoading(false)
                setShowLoginFailed(true)
            }
        } catch (error) {
            saveAuth(undefined)
            setLoading(false)
            setShowLoginFailed(true)
        }
    }

    function forgotPassword(e) {
        e.preventDefault()
        setShowForgotPassword(true)
    }

    function closeForgotPassword() {
        setShowForgotPassword(false)
    }

    function closeLoginFailed() {
        setShowLoginFailed(false)
    }

    function handleTryAgain() {
        setShowLoginFailed(false)
    }

    return (
        <>
            <div className={ "LoginBox" }>
                <div className={"flex gap-[10px] items-center"}>
                    <img alt={ "Logo" } src={ "/media/logos/favicon.svg" } className={ "w-[26px] h-[29px] " }/>
                    <div className={ "LoginHeaderTitle" }>
                        Listecles
                        <span className={ "LoginPurpleHeaderTitle" }>.ai</span>
                    </div>
                </div>
                <form
                    onSubmit={ handleSubmit(onSubmit) }
                    noValidate
                    id='kt_login_signin_form'
                    className={ "flex flex-col w-full gap-4" }
                >
                    <div className={ "flex flex-col gap-[6px]" }>
                        <div className={ "XSmallMediumText" }>Email</div>
                        <input className={ "TextInput" }
                               { ...register("email") }
                               placeholder='Email'
                               id="EmailInput"
                               name='email'
                               autoComplete='off'/>
                    </div>
                    <div className={ "flex flex-col gap-[6px]" }>
                        <div className={ "XSmallMediumText" }>Password</div>
                        <input className={ "TextInput" }
                               { ...register("password") }
                               placeholder='Password'
                               id="PasswordInput"
                               type='password'
                               autoComplete='off'/>
                    </div>
                    <button className={"XSmallMediumText text-left"} onClick={forgotPassword}>Forgot password?</button>
                    <div className={ "flex items-center gap-6 w-full" }>
                        <button
                            type='submit'
                            id='kt_sign_in_submit'
                            className={ clsx("PrimaryButton min-h-9", "w-full") }
                            disabled={ !isValid }
                        >
                            { !loading && <span>Login</span> }
                            { loading && (
                                <span className='indicator-progress'>
                        Please wait...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                            ) }
                        </button>
                    </div>
                </form>
            </div>

            { showForgotPassword &&
                <ForgotPassword close={ closeForgotPassword } />
            }
            
            { showLoginFailed &&
                <LoginFailedPopup 
                    close={ closeLoginFailed } 
                    onTryAgain={ handleTryAgain }
                />
            }
        </>
    )
}